<template>
  <div class="site-header__search">
    <form
      action="/search"
      class="form form--block"
    >
      <input
        :value="input"
        class="site-header__search-box form__control"
        name="q"
        type="text"
        placeholder="Search"
        autocomplete="off"
        @input="handleInput"
      >
      <div class="site-header__search-controls">
        <a class="js__site-header__search-close site-header__search-close" href="#">
          <i class="fas fa-times"></i>
        </a>
      </div>
    </form>

    <div
      v-if="search.artists.length > 0 ||
        search.gigs.length > 0 ||
        search.articles.length > 0 ||
        search.articleVideos.length > 0
      "
      class="site-header__search-results"
    >
      <div class="site-header__search-results-container container">
        <div class="site-header__search-results-left">
          <h3 class="site-header__search-results-header">
            Artists
          </h3>

          <template v-if="search.artists.length > 0">
            <div
              v-for="artist in search.artists"
              :key="artist.id"
            >
              <a :href="artist.url">
                {{ artist.name }}
              </a>
            </div>
          </template>
          <div
            v-else
            class="no-matches">
            No matches found.
          </div>

          <h3 class="site-header__search-results-header">
            Gigs
          </h3>

          <template v-if="search.gigs.length > 0">
            <div
              v-for="gig in search.gigs"
              :key="gig.id"
            >
              <a :href="gig.url">
                <div
                  :style="{ 'background-image': `url(${gig.imageUrl})` }"
                  class="site-header__search-results-gig-image"
                />
                <p class="site-header__search-results-gig-title">{{ gig.title }}</p>
              </a>
            </div>
          </template>
          <div
            v-else
            class="no-matches"
          >
            No matches found.
          </div>
        </div>

        <div class="site-header__search-results-right">
          <h3 class="site-header__search-results-header">
            Articles
          </h3>

          <template v-if="search.articles.length > 0">
            <div
              v-for="article in search.articles"
              :key="article.id"
              class="site-header__search-results-result"
            >
              <a :href="article.url" class="site-header__search-results-link">
                <div
                  :style="{ 'background-image': `url(${article.image})` }"
                  class="site-header__search-results-image"
                />
                <div class="site-header__search-results-block">
                  <div class="site-header__search-results-title">{{ article.title }}</div>
                  <div class="site-header__search-results-author" v-if="article.author">{{ article.author }}</div>
                  <div class="site-header__search-results-author" v-else>Bandwagon Team</div>
                  <span class="site-header__search-results-secondary-text">
                    {{ article.categories[0].name }} /
                    {{
                      new Date(article.publishedAt).toLocaleDateString("en-sg", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })
                    }}
                  </span>
                </div>
              </a>
            </div>

            <a
              :href="`/search?q=${query}`"
              class="site-header__search-results-view-more"
            >
              View all articles
            </a>
          </template>
          <div
            v-else
            class="no-matches"
          >
            No matches found.
          </div>

          <hr>

          <h3 class="site-header__search-results-header">
            Videos
          </h3>

          <template v-if="search.articleVideos.length > 0">
            <div
              v-for="video in search.articleVideos"
              :key="video.id"
              class="site-header__search-results-result"
            >
              <a :href="video.url" class="site-header__search-results-link">
                <div
                  :style="{ 'background-image': `url(${video.featuredImage})` }"
                  class="site-header__search-results-image"
                />
                <div class="site-header__search-results-block">
                  <div class="site-header__search-results-title">{{ video.title }}</div>
                  <div class="site-header__search-results-author">{{ video.authorName }}</div>
                  <span class="site-header__search-results-secondary-text">
                    {{
                      new Date(video.publishedAt).toLocaleDateString("en-sg", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })
                    }}
                  </span>
                </div>
              </a>
            </div>

            <a
              :href="`/search?q=${query}`"
              class="site-header__search-results-view-more"
            >
              View all videos
            </a>
          </template>
          <div
            v-else
            class="no-matches"
          >
            No matches found.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import gql from 'graphql-tag';

const SEARCH_QUERY = gql`
  query searchQuery($query: String!, $country: String!) {
    search(query: $query, country: $country) {
      articles {
        id
        title
        publishedAt
        url
        image
        author
        categories {
          name
        }
      }
      articleVideos {
        id
        title
        publishedAt
        url
        featuredImage
        authorName
      }
      artists {
        id
        name
        url
      }
      gigs {
        id
        title
        url
        imageUrl
      }
    }
  }
`;

export default {
  apollo: {
    search: {
      query: SEARCH_QUERY,
      variables() {
        return {
          country: this.country,
          query: this.query,
        };
      },
      skip() {
        return this.query.length === 0;
      },
    },
  },
  props: {
    country: {
      type: String,
      default: 'SG',
    },
  },
  data() {
    return {
      query: '',
      input: '',
      search: {
        articles: [],
        articleVideos: [],
        artists: [],
        gigs: [],
      },
    };
  },
  methods: {
    handleInput: function(event) {
      this.input = event.target.value;
      this.updateQuery()
    },
    updateQuery: _.debounce(function() {
      this.query = this.input
    }, 500),
  },
};
</script>
